/** cookie url 映射 */
export enum CookieUrlMap {
  // 钱包基础
  HKWALLET = 'https://hkwallet.moneydata.hk/api/',
  // 运营活动
  PROM = 'https://prom.moneydata.hk/api/',
  // 生活缴费HK
  BILL_PAYMENT = 'https://bill-payment.wechatpay.com.hk/api/',
  // 电讯缴费HK
  APPS = 'https://apps.wechatpay.com.hk/api/',
  // We Remit
  REMIT = 'https://remit.moneydata.hk/api/',
  // FPSTransfer
  TRANSFER = 'https://transfer.moneydata.hk/api/',
  // Hong Kong Red Packets
  HONGBAO = 'https://hb.wechatpay.com.hk/api/',
}

/** LiteApp全局数据配置 */
export type LiteAppGlobalDataConfig = {
  cookieUrl: CookieUrlMap | undefined;
};
